export default __webpack_public_path__ + "static/media/hkdm1342-lives-high.de434da4.png";